
import { ajax } from 'utils';
import { PromiseAction } from '../types/promiseAction';
import { Response } from '../types/commons/response';
import * as types from '../types/smSupplierManagement';

export const GET_SUPPLIER_DETAIL = 'mpc/outSupplierManagement/get_supplier_detail';
export const GET_SUPPLIER_DETAIL_SUCCESS = 'mpc/outSupplierManagement/get_supplier_detail_success';
export const GET_SUPPLIER_DETAIL_FAIL = 'mpc/outSupplierManagement/get_supplier_detail_fail';
export const CHANGE_DETAIL = 'mpc/outSupplierManagement/change_detail';
export const SAVE_SUPPLIER_DETAIL = 'mpc/outSupplierManagement/save_supplier_detail';
export const SAVE_SUPPLIER_DETAIL_SUCCESS = 'mpc/outSupplierManagement/save_supplier_detail_success';
export const SAVE_SUPPLIER_DETAIL_FAIL = 'mpc/outSupplierManagement/save_supplier_detail_fail';
export const GET_SUPPLIER_OPTIONS_SUCCESS = 'mpc/outSupplierManagement/get_supplier_options_success';

export interface GetDetailSuccess {
  type: typeof GET_SUPPLIER_DETAIL_SUCCESS;
  data: types.SupplierMangementDetail;
}

export interface ChangeDetail {
  type: typeof CHANGE_DETAIL;
  data: types.SupplierMangementDetail;
}

export interface PureType {
  type: typeof SAVE_SUPPLIER_DETAIL | typeof SAVE_SUPPLIER_DETAIL_FAIL
  | typeof GET_SUPPLIER_DETAIL | typeof GET_SUPPLIER_DETAIL_FAIL;
}

export interface SaveDetailSuccess {
  type: typeof SAVE_SUPPLIER_DETAIL_SUCCESS;
  data: Response;
}

export type SupplierManagementActions = GetDetailSuccess | ChangeDetail | SaveDetailSuccess | PureType;

export function getDetail(body: types.RequireDetailItem, options = { isEdit: false }): PromiseAction {
  const { isEdit } = options;
  return {
    types: [GET_SUPPLIER_DETAIL, GET_SUPPLIER_DETAIL_SUCCESS, GET_SUPPLIER_DETAIL_FAIL],
    promise: () => ajax({
      url: isEdit ? 'outsource/v2/suppliers/edit' : 'outsource/v2/suppliers/detail',
      method: 'POST',
      body,
    }),
  };
}

/** 保存数据 */
export function saveDetail(body: types.SupplierMangementSaveDetail): PromiseAction {
  return {
    types: [SAVE_SUPPLIER_DETAIL, SAVE_SUPPLIER_DETAIL_SUCCESS, SAVE_SUPPLIER_DETAIL_FAIL],
    promise: () => ajax({
      url: 'outsource/v2/suppliers/apply_audit',
      method: 'POST',
      body,
    }).then((res: any) => {
      if (res.data && res.data.full_message) {
        throw res.data;
      }
      return res;
    }),
  };
}

// 修改数据
export function chagneDetail(data: types.SupplierMangementDetail) {
  return {
    type: CHANGE_DETAIL,
    data,
  };
}
